import adminNav from './admin-navigation';
import dealerNav from './dealer-navigation';
import warrantyNav from './warranty-navigation';
import customerNav from './customer-navigation';
import router from '@/router/index';
import { viewAccess, viewPermission } from '@/utils/utils';
import { broadcastAuthEvent } from '@/utils/sessionSync';
import store from '@/store';

const menu = [
  ...adminNav,
  ...dealerNav,
  ...warrantyNav,
  ...customerNav,
];

const menuPermissions = [
  { key: 'masterdata_menu', module: 'masterdata', titles: ['Master Data'] },
  { key: 'dashboard_menu', module: 'dashboard', titles: ['Dashboard'] },
  { key: 'order_menu', module: 'order', titles: ['Purchase Order'] },
  { key: 'sales_order_menu', module: 'sales', titles: ['Sales Order'] },
  { key: 'inventory_menu', module: 'inventory', titles: ['Inventory'] },
  { key: 'delivery_order_menu', module: 'delivery', titles: ['Delivery Orders'] },
  { key: 'shipping_menu', module: 'shipping', titles: ['Shipping'] },
  { key: 'self_collect_menu', module: 'self collect', titles: ['Self Collect'] },
  { key: 'return_delivery_menu', module: 'return delivery', titles: ['Return Delivery', 'Manual Return'] },
  { key: 'redelivery_menu', module: 'redelivery', titles: ['Redelivery'] },
  { key: 'kioskWarehouse_menu', module: 'kioskWarehouse', titles: ['Kiosk Warehouse'] },
  { key: 'kioskKpi_menu', module: 'kioskKpi', titles: ['Kiosk KPI'] },
  { key: 'warranty_menu', module: 'warranty', titles: ['Warranty'] },
  { key: 'warranty_master_menu', module: 'warranty master', titles: ['Warranty Master'] },
  { key: 'report_menu', module: 'report', titles: ['Report'] },
  { key: 'kioskReport_menu', module: 'kioskeReport', titles: ['eKiosk Report'] },
  { key: 'settings_menu', module: 'settings', titles: ['Settings'] },
  { key: 'retrigger_api_menu', module: 'userAccess_resend', titles: ['Retrigger API'] },
  { key: 'manualcreate_menu', module: 'manualcreate', titles: ['Manual Create'] },
  { key: 'counter_menu', module: 'counter', titles: ['Counter'] },
  { key: 'utilitytools_menu', module: 'utilitytools', titles: ['Utility Tools'] },
];

const permissionError = function (module = '') {
  alert('Your session has expired, please login again');

  const logData = router.app.$session.get('userID')
    ? {
      id: router.app.$session.get('userID'),
      message: 'Logged Out Automatically',
    }
    : {
      email: 'noname@rsp.com',
      message: '[USER ID NOT FOUND] - Logged Out Automatically',
      name: 'noname',
    };

  store.dispatch('log/addLog', logData).then(() => {
    broadcastAuthEvent('logout', router.app.$session.get('userID'));
    router.app.$session.clear();
    router.app.$session.destroy();
    window.location.reload();
  });
};

const getSessionPermission = () => {
  const permissionText = router.app.$session.get('permission');
  if (!permissionText) {
    router.push('/pages/login');
    return null;
  }

  try {
    return JSON.parse(permissionText);
  } catch (error) {
    console.error('Failed to parse permission session data:', error);
    permissionError('permission_parse');
    return null;
  }
};

const isSessionExpired = () => {
  const expireTime = router.app.$session.get('expireTime');
  if (!expireTime) {
    return true;
  }

  return Number(expireTime) - Date.now() < 0;
};

const getAllAccessViewAuth = (title = '') => {
  const findMenu = menu.find((el) => el.title === title);
  if (!findMenu) {
    return [];
  }

  if (Array.isArray(findMenu.children)) {
    return findMenu.children
      .map((child) => child.route)
      .filter(Boolean)
      .map((route) => route.replace(/\s+/g, '-').toLowerCase());
  }

  if (findMenu.route) {
    return [findMenu.route.replace(/\s+/g, '-').toLowerCase()];
  }

  return [];
};

const buildNavMenu = () => {
  const navMenu = [];
  const permission = getSessionPermission();

  if (!permission) {
    return navMenu;
  }

  if (isSessionExpired()) {
    permissionError('expiration');
    return navMenu;
  }

  menuPermissions.forEach((menuPermission) => {
    const userAccess = permission.allAccess
      ? menuPermission.titles
        .map((title) => getAllAccessViewAuth(title))
        .flat()
      : viewAccess(menuPermission.key);

    // Non-allAccess users can have partial permission payloads.
    // Missing module permissions should only hide that module, not force logout.
    if (!userAccess) {
      console.info(
        `userAccess ${menuPermission.module} get permission returns error`,
      );
      return;
    }

    menuPermission.titles.forEach((title) => {
      viewPermission(menu, title, navMenu, userAccess);
    });
  });

  return navMenu;
};

const navMenu = buildNavMenu();

export default navMenu;